import Idea from "./idea";
import { useAppSelector } from "@/redux/store/hooks";
import { Box } from "@/storybook-components";

const Banner = () => {
  const { brainstormers } = useAppSelector((state) => state.brainstormers);

  return (
    <Box as="ul" listStyleType="none">
      {[...brainstormers]
        .sort((a, b) => a.sequence - b.sequence)
        .map((brainstormer) => (
          <Box
            as="li"
            p={0}
            my="10px"
            listStyleType="none"
            key={brainstormer.id}
            border="1px solid #ececec"
          >
            <Idea brainstormer={brainstormer} />
          </Box>
        ))}
    </Box>
  );
};

export default Banner;
